<div class="input-group">

    <div class="form-control d-flex" [ngClass]="{'data-required':control.touched && control.invalid}"
        style="border-radius: 0.185rem 0  0 0.185rem; width: 80px; max-width: 80px; border-right: 0px; padding-right: 0px;">
        

        <img src="/images/flags/chile.png" width="20" height="14" alt="Imagen de bandera de Chile">

        <label style="padding-left: 5px; margin: 0px;" >+56&nbsp;&nbsp;9</label>
        

    </div>

    <input class="form-control" maxlength="8" style="border-left: 0px; padding-left: 5px; " [ngClass]="{'is-invalid':control.touched && control.invalid}" [formControl]="control" [id]="id" [name]="id" [title]="title"
        [placeholder]="placeholder">
    </div>
 